/**
 * @enum PagesId
 * 
 * Represents all unique page identifiers within the application.
 * 
 * Each enum key corresponds to a specific page ID, while its value
 * represents the **relative path** to that page.
 * 
 * This enum can be used as a reliable reference for:
 * - Generating or composing routes dynamically
 * - Mapping translations or SEO data by page
 * - Maintaining consistent internal navigation identifiers
 * 
 * Example:
 * ```ts
 * import { PagesId } from '@ts/enums/PagesId'
 * 
 * const route = `/${PagesId.Home}`
 * // -> ''
 * ```
 */
export enum PagesId {
  Home = 'home',
  ContactUs = 'contact-us',
  LegalHome = 'legal-home',
  LegalPrivacyPolicy = 'legal-privacy-policy',
  LegalTermsAndConditions= 'legal-terms-and-conditions',
  LegalRefundPolicy = 'legal-refund-policy',
  OrdersHome = 'orders-home',
  CreateManualUserOrders = 'create-manual-user-orders',
  CreateManualStoreOrders = 'create-manual-store-orders',
  OrdersPaymentMethods = 'orders-payment-methods',
  HowToCancelOrders = 'how-to-cancer-orders',
  OrdersReturns = 'orders-returns',
  ManagingPaymentsForOrders = 'managing-payments-for-orders',
  ManagingDocsForOrders = 'managing-docs-for-orders',
  ItemsHome = 'items-home',
  CreateItems = 'create-items',
  UpdateItems = 'update-items',
  ManageItemsMedia = 'manage-items-media',
  WriteOffInventory = 'write-off-inventory',
  PricingYourProducts = 'pricing-your-products',
}
